import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=7220b456&scoped=true&"
import script from "./topics.vue?vue&type=script&lang=js&"
export * from "./topics.vue?vue&type=script&lang=js&"
import style0 from "./topics.vue?vue&type=style&index=0&id=7220b456&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220b456",
  null
  
)

export default component.exports